// @flow

import * as React from "react";

type PropsType = {
    className?: string,
    lat: number,
    lng: number,
    width: number,
    height?: number,
    zoom?: number,
    marker?: boolean,
};

class GoogleMap extends React.Component<PropsType> {
    mapRef = React.createRef<HTMLDivElement>();
    componentDidMount() {
        const myLatLng = { lat: this.props.lat, lng: this.props.lng };
        const map = new window.google.maps.Map(this.mapRef.current, {
            center: {
                lat: this.props.lat,
                lng: this.props.lng,
            },
            zoom: this.props.zoom || 16,
            mapTypeControl: false,
            zoomControl: true,
            fullscreenControl: false,
            streetViewControl: true,
            gestureHandling: "cooperative",
            styles: [
                {
                    featureType: "poi",
                    stylers: [{ visibility: "off" }],
                },
            ],
        });

        const image = {
            url: `${window.drupalAssetsDir}/images/google-pin.svg`,
        };

        new window.google.maps.Marker({
            position: myLatLng,
            icon: image,
            map: map,
        });
    }

    render(): any {
        return (
            <div className="google-map__map-outer">
                <div ref={this.mapRef} className="google-map__map-inner" />
            </div>
        );
    }
}

export default GoogleMap;
